import React from 'react';
import { BrandMark } from '../shared/BrandMark';

export type OrbState = 'idle' | 'listening' | 'thinking' | 'unavailable';
export type OrbSize = 'nav' | 'mic' | 'hero';

const MARK_HEIGHT: Record<OrbSize, number> = {
  nav: 12,
  mic: 22,
  hero: 44,
};

export function GlowingOrb({
  state = 'idle',
  size = 'mic',
  className,
}: {
  state?: OrbState;
  size?: OrbSize;
  className?: string;
}) {
  return (
    <span
      className={`maitre-orb maitre-orb-${size} maitre-orb-${state}${
        className ? ` ${className}` : ''
      }`}
      aria-hidden
    >
      <span className="maitre-orb-glow" />
      <BrandMark className="maitre-orb-mark" height={MARK_HEIGHT[size]} />
      <span className="maitre-orb-sheen" />
    </span>
  );
}
